import iframeResize from '@iframe-resizer/parent'
import debounce from '@node_modules/lodash/debounce'
import startsWith from '@node_modules/lodash/startsWith'

window.initializeIframe = function (iframeId, isRatesTable = false) {
    const iframe = document.querySelector(iframeId)
    let iframeReady = false

    if (iframe?.dataset?.src) {
        iframe.src = iframe?.dataset?.src
        iframeReady = true
    }

    window.addEventListener(
        'scroll',
        debounce(
            function () {
                if (iframeReady) {
                    handleScroll(iframeId)
                }
            },
            100,
            { trailing: true },
        ),
    )

    window.addEventListener(
        'message',
        event => {
            let messageContent = event.data
            if (startsWith(messageContent, 'declinedOffersPosition')) {
                let declinedOffersPosition = messageContent.replace('declinedOffersPosition|', '  ')

                window.scrollTo({
                    top: declinedOffersPosition,
                    left: 0,
                    behavior: 'smooth',
                })
            }
        },
        false,
    )

    if (!isRatesTable) {
        iframeResize(
            {
                warningTimeout: 20000,
                checkOrigin: false,
                license: '1jy4dww5qzv-s54r73oxcn-v59f4kfgfz',
            },
            iframeId,
        )
    }

    const interval = setInterval(() => {
        if (iframeReady) {
            postMessage(iframeId)
            clearInterval(interval)
        }
    }, 100)
}

let modalOffset = 50
let windowHeight = window.innerHeight
let iframeOffsetBottom = 0
let scrollBottom = 0
let iframeOffsetTop = 0

function handleScroll(iframeId) {
    let iframe = document.querySelector(iframeId)
    let scrollTop = document.scrollingElement.scrollTop
    let iframeTop = iframe.getBoundingClientRect().top + window.scrollY
    iframeOffsetBottom = iframe.getBoundingClientRect().bottom + window.scrollY
    iframeOffsetTop = iframe.offsetTop
    windowHeight = window.innerHeight
    modalOffset = scrollTop - iframeTop
    scrollBottom = window.scrollY + windowHeight

    if (modalOffset < 1) {
        modalOffset = 50
    } else {
        modalOffset = modalOffset + 50
    }

    iframe.contentWindow.postMessage(
        `iframeVariables|${modalOffset}|${windowHeight}|${iframeOffsetBottom}|${scrollBottom}|${iframeOffsetTop}`,
        '*',
    )
}

function postMessage(iframeId) {
    var iframe = document.querySelector(iframeId)
    iframe.contentWindow.postMessage(`modalOffset|${modalOffset}`, '*')

    setInterval(function () {
        iframe.contentWindow.postMessage(
            `iframeVariables|${modalOffset}|${windowHeight}|${iframeOffsetBottom}|${scrollBottom}|${iframeOffsetTop}`,
            '*',
        )
    }, 500)
}
